export const isVideoLink = (link: string): boolean => {
  const videoExtensions = ['.mp4', '.avi', '.mov', '.mkv', '.wmv', '.webm', '.flv', '.m4v', '.3gp'];

  const fileExtension = link.substring(link.lastIndexOf('.'));

  return videoExtensions.includes(fileExtension);
};
